import { useState, useEffect } from "react";
import Modulo from "../../components/modulo";
import "../../style/style-cargando.css";
import sinAccesoCard from "../../components/sin-acceso-card";
import cargandoCard from "../../components/cargando-card";
import { MODULOS_ADMINISTRACION } from "./modulos-administracion";
import { obtenerInfoUsuario } from "../../api/api-usuario-web";
import { TIPO_USUARIO_WEB } from "../../utils/const/int-const";

// const idTipoUsuario = parseInt(localStorage.getItem("tipoUsuarioChecklist"));

export default function AdministracionIndex() {

    // const [permisos, setPermisos] = useState(null);
    const [cargandoPage, setCargandoPage] = useState(false);
    const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(true);
    const [modulos, setModulos] = useState([]);

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            /*let objPermiso = {};
            objPermiso.idMenuPrimerNivel = INT_ID_MODULO_CONFIGURACION;
            objPermiso.idMenuSegundoNivel = 0;
            objPermiso.idMenuTercerNivel = 0;
            let obtenerPermisos = await obtenerPermisosPorNivelUsuarioWeb(objPermiso);
            // console.log('obtenerPermisos');
            // console.log(obtenerPermisos);
            let permiso = obtenerPermisos[0];
            setPermisos(permiso);
            // console.log('idTipoUsuario');
            // console.log(idTipoUsuario);
            // debugger;
            if (idTipoUsuario === INT_TIPO_USUARIO_ADMINISTRADOR_WEB) {
                setTieneAccesoAlModulo(true);
            }
            if (idTipoUsuario !== INT_TIPO_USUARIO_ADMINISTRADOR_WEB) {
                if (permiso.accesoAlModulo === TRUE) {
                    setTieneAccesoAlModulo(true);
                }
            }*/
            const objUsuario = await obtenerInfoUsuario();
            // console.log('objUsuario');
            // console.log(objUsuario);
            if (objUsuario.error === false && objUsuario.body.value !== null) {
                let mod = [];
                if (objUsuario.body.value.idTipoUsuarioWeb === TIPO_USUARIO_WEB.REGULAR) {
                    mod = MODULOS_ADMINISTRACION.filter((data) => data.tipoUsuario === TIPO_USUARIO_WEB.REGULAR);
                }
                if (objUsuario.body.value.idTipoUsuarioWeb === TIPO_USUARIO_WEB.SUPER_ADMIN) {
                    mod = MODULOS_ADMINISTRACION.filter((data) => data.tipoUsuario === TIPO_USUARIO_WEB.SUPER_ADMIN);
                }
                // console.log('mod');
                // console.log(mod);
                setModulos(mod);
            }

            setCargandoPage(false);
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
            setCargandoPage(false);
        }
    }

    const render = () => {
        try {
            if (cargandoPage === true) {
                return cargandoCard();
            }
            if (tieneAccesoAlModulo === false) {
                return sinAccesoCard();
            }
            return (
                <div>
                    <div className="flex flex-wrap">
                        {modulos.map((data) => Modulo(data))}
                    </div>
                </div>
            );
        } catch (err) {
            console.log("Index render");
            console.log(err);
            return (
                <div className=" w-1/2 m-auto px-[2rem] ">
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    };

    return render();
}
